import { twMerge } from '@/lib/twMerge';
interface ThemeIconProps {
  children: React.ReactNode;
  className?: string;
}
const ThemeIcon = ({
  children,
  className
}: ThemeIconProps) => <div className={twMerge('absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 items-center justify-center opacity-100 transition-all duration-300', className)} data-sentry-component="ThemeIcon" data-sentry-source-file="ThemeIcon.tsx">
    {children}
  </div>;
export default ThemeIcon;